// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__kTSyM","footerText":"footer_footerText__38TDN"};